/* tslint:disable */
/* eslint-disable */
import { AntwortDisplayModel as AceXFoundPortalCoreCaqModelsAntwortDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/antwort-display-model';
import { FrageAuswahlDisplayModel as AceXFoundPortalCoreCaqModelsFrageAuswahlDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/frage-auswahl-display-model';
import { LocalizedTextDisplayModel as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { GlobalEnumsAceFeldtyp as AceXFoundPortalCoreEntitiesGlobalEnumsAceFeldtyp } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-feldtyp';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { AntwortDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsAntwortDisplayModelFormGroup } from '@/api/model-index';
import { FrageAuswahlDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsFrageAuswahlDisplayModelFormGroup } from '@/api/model-index';
import { LocalizedTextDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup } from '@/api/model-index';

export interface IFrageDisplayModel {
  abschnittId?: null | string;
  answer?: AceXFoundPortalCoreCaqModelsAntwortDisplayModel;
  anzahlDerZeilen?: null | number;
  feldTyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAceFeldtyp;
  frageAuswahl?: AceXFoundPortalCoreCaqModelsFrageAuswahlDisplayModel;
  frageId: string;
  headline?: null | string;
  infotext?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  isRequired: boolean;
  maxLength?: null | number;
  order: number;
  texts?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  vorlageAntwort?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
}
export class FrageDisplayModel extends BaseModel implements IFrageDisplayModel {
  abschnittId?: null | string;
  answer?: AceXFoundPortalCoreCaqModelsAntwortDisplayModel;
  anzahlDerZeilen?: null | number;
  feldTyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAceFeldtyp;
  frageAuswahl?: AceXFoundPortalCoreCaqModelsFrageAuswahlDisplayModel;
  frageId: string;
  headline?: null | string;
  infotext?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  isRequired: boolean;
  maxLength?: null | number;
  order: number;
  texts?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  vorlageAntwort?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
}
class BaseFrageDisplayModelFormGroup extends FormGroup {
  private static _instance: FrageDisplayModelFormGroup;
  
  public static get Instance(): FrageDisplayModelFormGroup {
    this._instance = new FrageDisplayModelFormGroup({
      abschnittId: new FormControl(null),
      answer: AceXFoundPortalCoreCaqModelsAntwortDisplayModelFormGroup.Instance,
      anzahlDerZeilen: new FormControl(null),
      feldTyp: new FormControl(null),
      frageAuswahl: AceXFoundPortalCoreCaqModelsFrageAuswahlDisplayModelFormGroup.Instance,
      frageId: new FormControl(null, [Validators.required]),
      headline: new FormControl(null),
      infotext: new FormArray([]),
      isRequired: new FormControl(null, [Validators.required]),
      maxLength: new FormControl(null),
      order: new FormControl(null, [Validators.required]),
      texts: new FormArray([]),
      vorlageAntwort: new FormArray([]),
    });

    return this._instance;
  }
}


export class FrageDisplayModelFormGroup extends BaseFrageDisplayModelFormGroup {
  public get AbschnittId(): FormControl {
    return this.controls["abschnittId"] as FormControl;
  }
  public get Answer(): AceXFoundPortalCoreCaqModelsAntwortDisplayModelFormGroup {
    return this.controls["answer"] as AceXFoundPortalCoreCaqModelsAntwortDisplayModelFormGroup;
  }
  public get AnzahlDerZeilen(): FormControl {
    return this.controls["anzahlDerZeilen"] as FormControl;
  }
  public get FeldTyp(): FormControl {
    return this.controls["feldTyp"] as FormControl;
  }
  public get FrageAuswahl(): AceXFoundPortalCoreCaqModelsFrageAuswahlDisplayModelFormGroup {
    return this.controls["frageAuswahl"] as AceXFoundPortalCoreCaqModelsFrageAuswahlDisplayModelFormGroup;
  }
  public get FrageId(): FormControl {
    return this.controls["frageId"] as FormControl;
  }
  public get Headline(): FormControl {
    return this.controls["headline"] as FormControl;
  }
  public get Infotext(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["infotext"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get IsRequired(): FormControl {
    return this.controls["isRequired"] as FormControl;
  }
  public get MaxLength(): FormControl {
    return this.controls["maxLength"] as FormControl;
  }
  public get Order(): FormControl {
    return this.controls["order"] as FormControl;
  }
  public get Texts(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["texts"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get VorlageAntwort(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["vorlageAntwort"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  

}

export module FrageDisplayModelForm
  {
    export class FormFields
    {
      static _abschnittId: string = "abschnittId";
      static _answer: string = "answer";
      static _anzahlDerZeilen: string = "anzahlDerZeilen";
      static _feldTyp: string = "feldTyp";
      static _frageAuswahl: string = "frageAuswahl";
      static _frageId: string = "frageId";
      static _headline: string = "headline";
      static _infotext: string = "infotext";
      static _isRequired: string = "isRequired";
      static _maxLength: string = "maxLength";
      static _order: string = "order";
      static _texts: string = "texts";
      static _vorlageAntwort: string = "vorlageAntwort";
    }
  }

